import ArticleComponent from "../components/article/article-component";

export default function Article() {
    return(
        <>
            <ArticleComponent />
        </>
    )
}